<template>
    <div class="admin-content">
        <div class="left-wrapper">
            <el-menu :default-active="adminTab" class="left-nav">
                <el-menu-item index="adminHelpClassifies">
                    <router-link class="nav-item" to="/admin/help/classifies">分类管理</router-link>
                </el-menu-item>
                <el-menu-item index="adminHelpIndex">
                    <router-link class="nav-item" to="/admin/help/index">帮助管理</router-link>
                </el-menu-item>
                <el-menu-item index="adminHelpVideo">
                    <router-link class="nav-item" to="/admin/help/video">视频帮助</router-link>
                </el-menu-item>
            </el-menu>
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "AdminHelpLayout",
        data() {
            return {
                adminTab: '',
            }
        },
        created() {
            this.adminTab = this.$route.name;
        },
    }
</script>

<style scoped lang="scss">
    .left-nav {
        .el-menu-item {
            padding: 0!important;
            height: 46px;
            line-height:46px;
            border-left: 2px solid transparent;
            .nav-item {
                padding: 0 20px;
                display: block;
                color: #333;
            }
            &.is-active {
                height:46px;
                line-height:46px;
                .nav-item {
                    color: #1E34E4;
                }
            }
            &.is-active:after{
                position: absolute;
                content: '';
                height: 14px;
                width: 3px;
                background: #1E34E4;
                top: 16px;
            }
            &.el-menu-item:focus, &.el-menu-item:hover {
                outline: 0;
                background-color: transparent;
            }

        }
    }

</style>